/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // Example event listeners removed to avoid verbose console logs in production
  // Uncomment below if you need to use theme events for custom features

  /*
  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container , , , , , , , ,  ↓');
      console.log(container);
      console.log('Variant , , , , , , , , , ,  ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart , , , , , , , , , , , ,  ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });
  */

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Glossary Search Functionality
  // Handles AJAX search against the ig-snpsync app proxy endpoint
  document.addEventListener('DOMContentLoaded', function() {
    var section = document.querySelector('[data-glossary-section]');
    if (!section) return;

    var searchInput = section.querySelector('[data-glossary-search]');
    var defaultContainer = section.querySelector('[data-glossary-default]');
    var resultsContainer = section.querySelector('[data-glossary-results]');
    var noResultsEl = section.querySelector('[data-glossary-no-results]');
    var loadingEl = section.querySelector('[data-glossary-loading]');
    var errorEl = section.querySelector('[data-glossary-error]');
    var debounceTimer = null;
    var headingSizeClass = section.getAttribute('data-heading-size-class') || 'accent-size-5';
    var fontSizeClass = section.getAttribute('data-font-size-class') || 'body-size-5';

    if (!searchInput) return;

    searchInput.addEventListener('input', function() {
      var query = searchInput.value.trim();
      clearTimeout(debounceTimer);

      if (query.length === 0) {
        showDefault();
        return;
      }

      debounceTimer = setTimeout(function() {
        fetchResults(query);
      }, 300);
    });

    /* Accordion toggle via event delegation on search results */
    resultsContainer.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-glossary-trigger]');
      if (!trigger) return;

      var targetId = trigger.getAttribute('data-glossary-trigger');
      var body = resultsContainer.querySelector('#' + targetId);
      if (!body) return;

      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      body.style.display = isOpen ? 'none' : 'block';
    });

    function hideAll() {
      defaultContainer.style.display = 'none';
      resultsContainer.style.display = 'none';
      noResultsEl.style.display = 'none';
      loadingEl.style.display = 'none';
      errorEl.style.display = 'none';
    }

    function showDefault() {
      hideAll();
      defaultContainer.style.display = '';
    }

    function fetchResults(query) {
      hideAll();
      loadingEl.style.display = '';

      fetch('/apps/proxy/glossary/search?q=' + encodeURIComponent(query))
        .then(function(res) {
          if (!res.ok) throw new Error('Search request failed');
          return res.json();
        })
        .then(function(data) {
          hideAll();
          var results = data.results || [];

          if (results.length === 0) {
            noResultsEl.style.display = '';
            return;
          }

          resultsContainer.innerHTML = renderResults(results);
          resultsContainer.style.display = '';
        })
        .catch(function(err) {
          console.error('Glossary search error:', err);
          hideAll();
          errorEl.style.display = '';
        });
    }

    function renderResults(results) {
      var html = '';
      for (var i = 0; i < results.length; i++) {
        var term = results[i].term || '';
        var definition = results[i].definition || '';
        var handle = slugify(term) + '-' + i;

        html += '<div class="accordion__wrapper">'
          + '<button class="accordion__title js ' + headingSizeClass + '"'
          + ' data-glossary-trigger="glossary-result-' + handle + '"'
          + ' aria-controls="glossary-result-' + handle + '"'
          + ' aria-haspopup="true"'
          + ' aria-expanded="false">'
          + escapeHtml(term)
          + '</button>'
          + '<div class="accordion__body rte ' + fontSizeClass + '"'
          + ' id="glossary-result-' + handle + '"'
          + ' style="display: none;">'
          + '<p>' + escapeHtml(definition) + '</p>'
          + '</div>'
          + '</div>';
      }
      return html;
    }

    function slugify(text) {
      return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(text));
      return div.innerHTML;
    }
  });

  // DNA Report Download Functionality
  // Handles download button clicks, API requests, and UI state management
  document.addEventListener('DOMContentLoaded', function() {
    // Query for all DNA report download buttons
    const dnaReportButtons = document.querySelectorAll('[data-action="download-dna-report"]');

    if (dnaReportButtons.length === 0) {
      return; // Exit if no buttons found on page
    }

    // Attach click event listener to each button
    dnaReportButtons.forEach(function(button) {
      button.addEventListener('click', handleDownloadClick);
    });

    // Click event handler function
    function handleDownloadClick(event) {
      event.preventDefault(); // Prevent default button behavior

      const button = event.currentTarget;
      const customerId = button.getAttribute('data-customer-id');

      if (!customerId) {
        console.error('DNA Report Download Error: Customer ID not found');
        showError(button, 'Unable to download your report. Please refresh the page and try again.');
        return;
      }

      // Add loading state
      button.classList.add('loading');
      button.disabled = true;
      const originalText = button.innerHTML;
      const icon = button.querySelector('.icon');
      const iconHTML = icon ? icon.outerHTML : '';
      button.innerHTML = iconHTML + ' Downloading...';

      // Make API request
      downloadReport(customerId, button, originalText);
    }

    // API request implementation
    function downloadReport(customerId, button, originalText) {
      // Use same-origin proxy endpoint to ensure session cookies are sent
      // Backend should expose this endpoint and forward to API gateway with auth
      const apiUrl = '/apps/dna-reports/download?customerId=' + encodeURIComponent(customerId);

      // Determine open mode from button data attribute (default to download)
      const openMode = button.getAttribute('data-open-mode') || 'download';

      // Make GET request with credentials
      fetch(apiUrl, {
        method: 'GET',
        credentials: 'include', // Send Shopify customer session cookies
        headers: {
          'Accept': 'application/pdf, application/json'
        }
      })
      .then(function(response) {
        if (!response.ok) {
          // Handle HTTP errors
          return response.json().then(function(errorData) {
            throw new Error(errorData.message || 'Download failed');
          }).catch(function() {
            throw new Error('Unable to download your report. Please try again.');
          });
        }

        // Check for redirect
        if (response.redirected) {
          // Use anchor element to avoid popup blockers
          const anchor = document.createElement('a');
          anchor.href = response.url;
          anchor.target = '_blank';
          anchor.style.display = 'none';
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
          return null;
        }

        // Check content type to determine response format
        const contentType = response.headers.get('content-type');

        if (contentType && contentType.includes('application/json')) {
          // Response contains JSON with signed URL
          return response.json().then(function(data) {
            if (data.url) {
              // Use anchor element to avoid popup blockers
              const anchor = document.createElement('a');
              anchor.href = data.url;
              anchor.target = '_blank';
              anchor.style.display = 'none';
              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);
              return null;
            } else {
              throw new Error('No download URL provided');
            }
          });
        } else if (contentType && (contentType.includes('application/pdf') || contentType.includes('application/octet-stream'))) {
          // Response is binary file - return blob
          return response.blob();
        } else {
          throw new Error('Unexpected response type');
        }
      })
      .then(function(blob) {
        if (!blob) {
          // Already handled (JSON or redirect)
          return;
        }

        // Create object URL from blob
        const blobUrl = URL.createObjectURL(blob);

        if (openMode === 'open') {
          // Open in new tab without download
          window.open(blobUrl, '_blank');
          // Clean up after short delay
          setTimeout(function() {
            URL.revokeObjectURL(blobUrl);
          }, 1000);
        } else {
          // Default: trigger download
          const anchor = document.createElement('a');
          anchor.href = blobUrl;
          anchor.download = `DNA_Report_${customerId}.pdf`;
          anchor.style.display = 'none';

          // Append to body, click, and remove
          document.body.appendChild(anchor);
          anchor.click();

          // Clean up
          setTimeout(function() {
            URL.revokeObjectURL(blobUrl);
            document.body.removeChild(anchor);
          }, 100);
        }

        // Show success state
        button.classList.add('has-success');
        setTimeout(function() {
          button.classList.remove('has-success');
        }, 2000);
      })
      .catch(function(error) {
        // Handle errors
        console.error('DNA Report Download Error:', error);
        showError(button, 'Unable to download your report. Please try again or contact support.');
      })
      .finally(function() {
        // Remove loading state
        button.classList.remove('loading');
        button.disabled = false;
        button.innerHTML = originalText;
      });
    }

    // Display error message to user
    function showError(button, message) {
      // Remove any existing error messages
      const existingError = button.parentElement.querySelector('.dna-report-error');
      if (existingError) {
        existingError.remove();
      }

      // Create and insert error message
      const errorDiv = document.createElement('div');
      errorDiv.className = 'dna-report-error errors';
      errorDiv.textContent = message;

      // Insert after button
      button.parentElement.appendChild(errorDiv);

      // Auto-remove error after 10 seconds
      setTimeout(function() {
        if (errorDiv.parentElement) {
          errorDiv.remove();
        }
      }, 10000);
    }
  });

  // Web.P.31 (Maria, 2026-09-25): Account details panel shows the customer's
  // IGID instead of name/address. IGID is not a Shopify field, so it is
  // fetched from our own App Proxy route (same-origin, session cookies
  // carry the logged-in customer, mirrors the DNA-report fetch above).
  document.addEventListener('DOMContentLoaded', function() {
    const igidEl = document.querySelector('[data-account-igid]');
    if (!igidEl) {
      return; // not on the account page
    }
    fetch('/apps/q5/identity', {
      method: 'GET',
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('identity lookup failed: ' + response.status);
        }
        return response.json();
      })
      .then(function(data) {
        igidEl.textContent = data && data.igid ? data.igid : 'Unavailable';
      })
      .catch(function(error) {
        console.error('Account IGID lookup error:', error);
        igidEl.textContent = 'Unavailable';
      });

    // Prov.B.24: flush a provider code stashed at signup (ig-consent-gate.liquid
    // has no natural post-account-creation hook, so customer-register.liquid
    // stashes it and this fires once we know the account page loaded for a
    // real logged-in customer). One-shot: cleared whether it succeeds or not,
    // since a permanently-wrong code should not retry forever.
    (function(){
      var pending;
      try { pending = localStorage.getItem('ig_pending_provider_code'); } catch(e) { pending = null; }
      if (!pending) { return; }
      try { localStorage.removeItem('ig_pending_provider_code'); } catch(e) {}
      fetch('/apps/q5/provider-code', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: pending })
      }).catch(function(error){ console.error('Provider code capture error:', error); });
    })();

    // Prov.B.29: flush a provider's own NPI + lab-fulfillment choice stashed
    // at ig-provider-signup.liquid, same one-shot pattern as the provider
    // code capture above (this account page load is the first point where a
    // real, confirmed logged-in customer id exists).
    (function(){
      var pendingRaw;
      try { pendingRaw = localStorage.getItem('ig_pending_provider_onboard'); } catch(e) { pendingRaw = null; }
      if (!pendingRaw) { return; }
      try { localStorage.removeItem('ig_pending_provider_onboard'); } catch(e) {}
      var pending;
      try { pending = JSON.parse(pendingRaw); } catch(e) { pending = null; }
      if (!pending || !pending.npi) { return; }
      fetch('/apps/q5/provider-onboard', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(pending)
      }).catch(function(error){ console.error('Provider onboard capture error:', error); });
    })();

    // Prov.B.24: the "Provider access" panel (additional providers, dashboard
    // access only; the original/billing code above is not editable here).
    var panel = document.querySelector('[data-provider-access]');
    if (panel) {
      var listEl = panel.querySelector('[data-provider-list]');
      var addInput = panel.querySelector('[data-provider-add-input]');
      var addBtn = panel.querySelector('[data-provider-add-btn]');
      var msgEl = panel.querySelector('[data-provider-msg]');
      function renderList(codes){
        listEl.innerHTML = '';
        if (!codes || !codes.length) {
          listEl.innerHTML = '<li class="ig-pa-empty">No additional providers yet.</li>';
          return;
        }
        codes.forEach(function(code){
          var li = document.createElement('li');
          li.className = 'ig-pa-row';
          var span = document.createElement('span');
          span.textContent = code;
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'ig-pa-remove'; btn.textContent = 'Remove';
          btn.addEventListener('click', function(){ postAccess('remove', code); });
          li.appendChild(span); li.appendChild(btn);
          listEl.appendChild(li);
        });
      }
      function postAccess(action, code){
        if (msgEl) { msgEl.textContent = ''; }
        fetch('/apps/q5/provider-access', {
          method: 'POST', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: action, code: code })
        })
          .then(function(r){ return r.json().catch(function(){ return {}; }); })
          .then(function(d){
            if (msgEl) { msgEl.textContent = (d && d.message) || (d && d.ok ? 'Done.' : 'That did not work.'); }
            if (d && d.ok) { renderList(d.additional); if (addInput) { addInput.value = ''; } }
          })
          .catch(function(){ if (msgEl) { msgEl.textContent = 'That did not go through. Please try again.'; } });
      }
      if (addBtn && addInput) {
        addBtn.addEventListener('click', function(){
          var code = (addInput.value || '').trim().toUpperCase();
          if (!code) { return; }
          postAccess('add', code);
        });
      }
      fetch('/apps/q5/provider-access', { method: 'GET', credentials: 'include',
        headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(d){
          var billEl = panel.querySelector('[data-provider-billing]');
          if (billEl) { billEl.textContent = (d && d.billing_code) || 'None on file'; }
          renderList(d && d.additional);
        })
        .catch(function(){ if (msgEl) { msgEl.textContent = 'Could not load provider access.'; } });
    }
  });

})();
